// logging.ts
import { AsyncLocalStorage } from "async_hooks";
import pino from "pino";
import { inspect } from "util";
import { A } from "./env-info";
var baseLoggerOptions = {
  level: A.isProduction ? "info" : "debug"
};
var loggerStore = AsyncLocalStorage ? new AsyncLocalStorage() : void 0;
var loggerProxyHandler;
var clientChildProxy;
var clientTransmit;
if (A.isServer) {
  loggerProxyHandler = {
    get(target, property, receiver) {
      target = loggerStore?.getStore()?.get("logger") ?? target;
      return Reflect.get(target, property, receiver);
    }
  };
} else {
  baseLoggerOptions.browser = {
    transmit: {
      level: "error",
      send: (level, logEvent) => {
        if (logEvent.bindings.concat(logEvent.messages).some((thing) => thing?.[ignoreSymbol]))
          return;
        clientTransmit?.(level, logEvent);
      }
    }
  };
  loggerProxyHandler = {
    get(target, property, receiver) {
      target = clientChildProxy ?? target;
      return Reflect.get(target, property, receiver);
    }
  };
}
var baseLogger = pino(baseLoggerOptions);
var ignoreSymbol = Symbol("ignoreLog");
var logger = new Proxy(baseLogger, loggerProxyHandler);
var getChildLogger = (bindings) => baseLogger.child(bindings);
var setClientChildLogger = (bindings) => {
  clientChildProxy = baseLogger.child(bindings);
};
var setClientTransmit = (send) => {
  clientTransmit = send;
};
var replaceConsoleFunctions = () => {
  globalThis.baseLogger = baseLogger;
  if (A.isClient) {
    window.addEventListener("unhandledrejection", (e) => e.reason?.[ignoreSymbol] || logger.error(e.reason));
    window.addEventListener("error", (e) => e.error?.[ignoreSymbol] || logger.error(e.error));
  }
  console.debug = function(...args) {
    A.isServer ? logger.debug("legacy console.debug: " + args.map((a) => inspect(a)).join(" ")) : logger.debug(args[0], ...args.slice(1));
  };
  console.log = function(...args) {
    A.isServer ? logger.info("legacy console.log: " + args.map((a) => inspect(a)).join(" ")) : logger.info(args[0], ...args.slice(1));
  };
  console.warn = function(...args) {
    A.isServer ? logger.warn("legacy console.warn: " + args.map((a) => inspect(a)).join(" ")) : logger.warn(args[0], ...args.slice(1));
  };
  console.error = function(...args) {
    A.isServer ? logger.error("legacy console.error: " + args.map((a) => inspect(a)).join(" ")) : logger.error(args[0], ...args.slice(1));
  };
};
export {
  getChildLogger,
  ignoreSymbol,
  logger,
  loggerStore,
  replaceConsoleFunctions,
  setClientChildLogger,
  setClientTransmit
};
